/* eslint-disable comma-dangle */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import withRouter from './routes/withRouter';
import App from './App';
import './index.css';

const setNewAccessToken = (token) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('token', token);
  }
};

// eslint-disable-next-line import/prefer-default-export
export const setNewAccessTokenFuncToWindow = () => {
  window.setToken = setNewAccessToken;
};

setNewAccessTokenFuncToWindow();

const Home = withRouter(App);
const container = document.getElementById('notifications-root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Routes>
      <Route
        path="user/:userId/application/:applicationId"
        element={<Home />}
      />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
